module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-10-a70fe70f58029252c79f6e6813fd2697.jpg";